
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/v3/pairs/[address]",
      function () {
        return require("private-next-pages/info/v3/pairs/[address].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/v3/pairs/[address]"])
      });
    }
  